import { useQuery } from "@apollo/client";
import { useDispatch } from "react-redux";
import { addBooking } from "../actions/bookingActions";
import { useState, useEffect } from "react";
import { GET_BOOKINGS, GET_BOOKINGS_BY_EMAIL } from "../../graphql/queries";
import { expandBookings } from "../../util/booking/expandBookings";

const useLoadReduxStoreBookings = (businessId, email, selectedYear) => {
  const dispatch = useDispatch();
  const [bookings, setBookings] = useState(null);

  // Choose query and variables based on the presence of businessId.
  const query = businessId ? GET_BOOKINGS : GET_BOOKINGS_BY_EMAIL;
  const variables = businessId
    ? { businessId, staffId: null, selectedYear }
    : { email, selectedYear };

  // Set dynamic field name based on the query.
  const fieldName = businessId ? "getBookings" : "getBookingsByEmail";

  // Use Apollo's useQuery hook.
  const { loading, error, data, refetch } = useQuery(query, {
    variables, 
    skip: !selectedYear,
    fetchPolicy: "network-only", // Ensure you get fresh data from the server.
    onCompleted: (fetchedData) => { 
      if (fetchedData && fetchedData[fieldName]) {
        // Expand bookings using the selectedYear filter.
        const expandedBookings = expandBookings(fetchedData[fieldName]);
        // Optionally dispatch the expanded bookings to Redux.
        dispatch(addBooking(expandedBookings));
        setBookings(expandedBookings);
      }
    },
    onError: (err) => console.error("Error fetching bookings:", err),
  });

  useEffect(() => {
    if (!loading && !error && data) { 
      if (data && data[fieldName]) {
        const expandedBookings = expandBookings(data[fieldName]);
        dispatch(addBooking(expandedBookings));
        setBookings(expandedBookings);
      }
    }
  }, [loading, error, data, fieldName, dispatch]);

  // Return bookings and query state.
  return { bookings, loading, error, refetch };
};

export default useLoadReduxStoreBookings;
